<template>
  <div class="card">
    <FloatingBrowseOccurrences v-if="hasOccurrences" />
    <section class="head">
      <StatusTag :status="jorf.nature" />
      <SourceLink
        :href="`https://www.legifrance.gouv.fr/jorf/id/${jorf.jorftext_id}`"
        :label="jorf.jorf_title || 'Voir JORF'"
      />
      <FollawButton :element-id="jorf._id" :feature="FOLLAWED_FEATURES.JORFS" />
    </section>
    <section class="body">
      <!-- eslint-disable-next-line vue/no-v-html -->
      <p class="title" v-html="jorf.title" />
      <p class="issuer">{{ jorf.issuer }}</p>

      <!-- Use both spelling (correct then incorrect) to support the typo in the API -->
      <!-- (The second one can be removed once the API is fixed) -->
      <OccurrencesCollapse
        v-if="hasOccurrences"
        :occurrences="jorf.occurrences || jorf.occurences"
        is-secondary-color
      />

      <RecursiveTextContent
        :content="jorf.content"
        :only-show-highlight="false"
        :levels="JORF_LEVELS"
      />
    </section>
  </div>
</template>

<script setup>
import { computed } from "vue";
import StatusTag from "@follaw-fr/components/reusable/atoms/StatusTag.vue";
import SourceLink from "@follaw-fr/components/general/atoms/SourceLink.vue";
import FollawButton from "@follaw-fr/components/reusable/atoms/FollawButton.vue";
import OccurrencesCollapse from "@follaw-fr/components/reusable/atoms/OccurrencesCollapse.vue";
import RecursiveTextContent from "@follaw-fr/components/reusable/molecules/RecursiveTextContent.vue";
import { FOLLAWED_FEATURES } from "@follaw-fr/stores/user";
import { JORF_LEVELS } from "@follaw-fr/utils/recursive-texts";
import FloatingBrowseOccurrences from "@follaw-fr/components/reusable/atoms/FloatingBrowseOccurrences.vue";

const props = defineProps({
  jorf: {
    type: Object,
    required: true,
  },
});

const hasOccurrences = computed(
  () => Object.keys(props.jorf.occurrences || props.jorf.occurences).length > 0
);
</script>

<style scoped lang="scss">
.head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1.4px solid var(--clr-s2);
  padding-bottom: 12px;
}

.title {
  margin: 4px 0;
}

.issuer {
  margin-bottom: 12px;
  color: var(--clr-s7);
}
</style>
